import { render, staticRenderFns } from "./Gmb.vue?vue&type=template&id=18f44835&scoped=true&"
import script from "./Gmb.vue?vue&type=script&lang=js&"
export * from "./Gmb.vue?vue&type=script&lang=js&"
import style0 from "./Gmb.vue?vue&type=style&index=0&id=18f44835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f44835",
  null
  
)

export default component.exports